// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tabs[data-v-8092479e] .v-tabs-slider-wrapper{display:block!important}.position-relative[data-v-8092479e]{position:relative}.ga-1>*[data-v-8092479e]{pointer-events:auto}", ""]);
// Exports
module.exports = exports;
